import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";


const Terms = () => {
const navigate = useNavigate();
const [sticky, setSticky] = useState("");
const goToAboutSection = (name) => {
    navigate("/#"+name);
  };
  const classes = `main-header ${sticky} mobhide`;
  useEffect(() => {
        // fetchcourses();
        const handleScroll = () => {
         // sticky header
    
         const scrollTop = window.scrollY;
        const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
        setSticky(stickyClass);
        console.log(stickyClass);
       };
    
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
    
      }, []);
  
  return (
    <div className="main-body">
      {/* Terms & condition */}
    <section>
        <div className="termsconditionsmaindiv">
            <div className="container">
                <p className="about-head termsconditionshead">Terms and Conditions</p>
                <p className="terms-description">
                    Effective Date: 12th August 2025
                </p>
                <br />
                <p className="termshead">1. Introduction</p>
                <p className="terms-description">These Terms and Conditions (“Terms”) govern your access to and use of the Mansthal Farming Connection website (“Platform,” “we,” “our,” or “us”). By accessing, browsing, or registering on the Platform, you agree to be bound by these Terms. If you do not agree, you must discontinue use immediately.</p>

                <p className="termshead">2. Eligibility</p>
                <p className="terms-description">a) You must be at least 18 years old to use the Platform.<br />
                b) If you are under 18, you may only use the Platform with the consent and supervision of a parent or legal guardian.<br />
                c) You agree that the information you provide during registration is accurate, complete, and up to date.<br />
                </p>

                <p className="termshead">3. User Responsibilities</p>
                <p className="terms-description">
                a)You are solely responsible for any content you post, share, or transmit on the Platform.<br />
                b)You agree not to post unlawful, defamatory, abusive, obscene, threatening, or misleading content.<br />
                c)You must not upload viruses, malicious code, or attempt to hack, disrupt, or interfere with the Platform.
                </p>

                <p className="termshead">4. Prohibited Activities</p>
                <p className="terms-description">You agree not to:<br />
                a) Use the Platform for fraudulent or commercial exploitation without our consent.<br />
                b) Engage in harassment, intimidation, or abuse of other users.<br />
                c) Impersonate another person or misrepresent your affiliation.
                </p>

                <p className="termshead">5. Intellectual Property Rights</p>
                <p className="terms-description">
                a) All text, graphics, logos, designs, and software on the Platform (except user-generated content) are the property of Mansthal Farming Connection.<br />
                b) You may not copy, reproduce, distribute, or modify our content without prior written permission.
                </p>

                <p className="termshead">6. Third-Party Content</p>
                <p className="terms-description">
                a) The Platform may contain links to third-party websites.<br />
                b) We are not responsible for the accuracy, legality, or content of such external sites.
                </p>

                <p className="termshead">7. Account Suspension & Termination</p>
                <p className="terms-description">We reserve the right to suspend, restrict, or permanently terminate your account without notice if you violate these Terms or engage in activities that may harm the Platform or its users.</p>

                <p className="termshead">8. Limitation of Liability</p>
                <p className="terms-description">To the maximum extent permitted by law, Mansthal Farming Connection will not be liable for any direct, indirect, incidental, or consequential damages arising from your use of the Platform.</p>

                <p className="termshead">9. Governing Law & Jurisdiction</p>
                <p className="terms-description">These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in [City, State].</p>
            </div>
        </div>
    </section>
    </div>
  );
};

export default Terms;
